// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.app-fa-icon[data-v-fc2c05f4] {\n\tcolor: inherit;\n}\n.app-fa-icon[data-v-fc2c05f4] path {\n\tfill: currentColor;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
